import { render, staticRenderFns } from "./applicationCenter.vue?vue&type=template&id=196f4344&scoped=true"
import script from "./applicationCenter.vue?vue&type=script&lang=js"
export * from "./applicationCenter.vue?vue&type=script&lang=js"
import style0 from "./applicationCenter.vue?vue&type=style&index=0&id=196f4344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f4344",
  null
  
)

export default component.exports